import type { ServerData } from '@/types';

/**
 * Whether a `/cc/` collection page should be indexed: live, public, and at
 * least two upcoming events (a single-event collection is not a curated list).
 */
export function collectionIsIndexable(serverData: ServerData): boolean {
    if (!('collection' in serverData)) {
        return false;
    }
    const upcoming =
        serverData.events_in_collection?.upcoming?.pagination?.object_count ?? 0;
    return (
        serverData.collection.status === 'live' &&
        !serverData.collection.is_private &&
        upcoming >= 2
    );
}
